import axios from 'axios';

export default class redirectUS {
    constructor() {
        this.ready();
    }

    isBot() {
        const botUserAgents = [
            'googlebot',
            'bingbot',
            'slurp',
            'duckduckbot',
            'baiduspider',
            'yandexbot',
            'sogou',
            'exabot',
            'facebot',
            'ia_archiver',
            'chrome-lighthouse',
            'mediapartners-google',
            'adsbot-google',
            'google-adspeed-insights',
            'google page speed insights',
            'google-structured-data-testing-tool',
            'google-site-verification',
            'google-search-console',
            'googlebot-image',
            'speed insights',
        ];

        return botUserAgents.some((bot) => navigator.userAgent.toLowerCase().includes(bot));
    }

    ready() {
        const ignorePaths = ['/login', '/register', '/password/confirm', '/password/reset', 'password/expired'];
            
        if (!this.isBot() && !ignorePaths.some(path => window.location.pathname.includes(path))) {
            if (navigator.userAgent.indexOf('Linux; Android 11; moto g power') > -1) {
                setTimeout(() => {
                    window.location.href = '/us';
                }, 10000);
            } else {
                window.location.href = '/us';
            }
        }
    }
}

if (document.querySelector('meta[name="country"][content="US"]') && currentLocale() !== 'us') {
    new redirectUS();
}
